import React, { useEffect, useState } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { getCurrentUser, getMe } from '@/lib/api';

export default function RequireDesignerOrAdmin({ children }) {
  const location = useLocation();
  const [loading, setLoading] = useState(true);
  const [allowed, setAllowed] = useState(false);

  const derive = (u) => {
    if (!u) return false;
    const normalized = u?.user ? { ...u, ...u.user } : u;
    const roleCandidate = normalized.role || normalized.role_name || normalized.user?.role || normalized.user?.role_name || '';
    const r = String(roleCandidate).toLowerCase();
    const roleId = normalized.role_id || normalized.user?.role_id;
    return r === 'designer' || r === 'admin' || roleId === 1;
  };

  const checkLocal = () => {
    const u = getCurrentUser();
    setAllowed(derive(u));
    return !!u;
  };

  useEffect(() => {
    let mounted = true;
    async function init() {
      const hasLocal = checkLocal();
      const token = localStorage.getItem('tdv_auth_token');
      if (!hasLocal && token) {
        try {
          await getMe();
          checkLocal();
        } catch (e) {
          console.warn('RequireDesignerOrAdmin getMe failed:', e);
        }
      }
      if (mounted) setLoading(false);
    }
    init();
    const handler = () => { checkLocal(); };
    window.addEventListener('authChange', handler);
    window.addEventListener('storage', handler);
    return () => {
      mounted = false;
      window.removeEventListener('authChange', handler);
      window.removeEventListener('storage', handler);
    };
  }, []);

  if (loading) return <div className="flex justify-center py-12 text-sm text-muted-foreground">Checking access…</div>;
  if (!allowed) {
    const token = localStorage.getItem('tdv_auth_token');
    return <Navigate to={token ? '/login' : '/'} replace state={{ from: location }} />;
  }
  return children;
}
